import { AdminPanelSettingsRounded } from "@mui/icons-material";
import {
  alpha,
  Badge,
  Box,
  IconButton,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import * as _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { saveSettings } from "src/slices/settings";
import { useDispatch, useSelector } from "src/store";
const Settings = () => {
  // @ts-ignore
  const settings = useSelector((state) => state.settings);
  // @ts-ignore
  const { user } = useSelector((state) => state.users);
  const dispatch = useDispatch();
  // @ts-ignore
  const { currentCustomer } = useSelector((state) => state.customers);
  const [canAccessAdmin, setCanAccessAdmin] = useState(false);
  const { t } = useTranslation();
  const theme = useTheme();
  const initialized = useRef(null);

  const handleChange = (field, value) => {
    var aF = {};
    if (field === "adminMode") {
      aF.adminModeFor = value === true ? currentCustomer.id : null;
    }
    dispatch(
      saveSettings({
        ...settings,
        ...aF,
        [field]: value,
      }),
    );
  };

  useEffect(() => {
    if (initialized.current === undefined && currentCustomer && settings) {
      initialized.current = true;
      if (settings.adminModeFor === currentCustomer.id) {
        handleChange("adminMode", true);
      }
    }
    if (
      currentCustomer &&
      user &&
      user.member_set &&
      user.member_set.length > 0
    ) {
      if (_.find(user.member_set, { customer_id: currentCustomer.id })) {
        setCanAccessAdmin(true);
      }
    }
  }, [settings, currentCustomer, user]);

  if (!canAccessAdmin) return null;

  return (
    <Tooltip
      title={
        settings.adminMode
          ? t("Desactivar modo administrador")
          : t("Activar modo administrador")
      }
      arrow
      enterDelay={300}
    >
      <Box
        onClick={() => handleChange("adminMode", !settings.adminMode)}
        role="button"
        aria-label={
          settings.adminMode
            ? t("Desactivar modo administrador")
            : t("Activar modo administrador")
        }
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          px: settings.adminMode ? 1 : 0.5,
          py: settings.adminMode ? 0.5 : 0.25,
          borderRadius: 2,
          cursor: "pointer",
          bgcolor: (theme) =>
            theme.palette.mode === "dark"
              ? alpha(theme.palette.background.paper, 0.88)
              : settings.adminMode
                ? alpha(theme.palette.primary.main, 0.1)
                : "transparent",
          border: settings.adminMode
            ? `1.5px solid ${theme.palette.primary.main}`
            : (theme) => `1.5px solid ${alpha(theme.palette.divider, 0.5)}`,
          "&:hover": {
            bgcolor: (theme) =>
              theme.palette.mode === "dark"
                ? alpha(theme.palette.primary.main, 0.16)
                : alpha(theme.palette.primary.main, 0.15),
            boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.2)}`,
          },
        }}
      >
        <Badge
          variant={settings.adminMode ? "dot" : "standard"}
          overlap="circular"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          sx={{
            "& .MuiBadge-badge": {
              bgcolor: theme.palette.success.main,
              boxShadow: (theme) =>
                `0 0 0 2px ${
                  theme.palette.mode === "dark"
                    ? theme.palette.background.default
                    : theme.palette.background.paper
                }`,
              width: 12,
              height: 12,
              borderRadius: "50%",
            },
          }}
        >
          <IconButton
            color="inherit"
            size="medium"
            sx={{
              color: (theme) =>
                theme.palette.mode === "dark"
                  ? alpha(theme.palette.common.white, 0.92)
                  : settings.adminMode
                    ? theme.palette.primary.main
                    : theme.palette.text.secondary,
              bgcolor: "transparent",
              p: 0.5,
              "&:hover": {
                color: (theme) =>
                  theme.palette.mode === "dark"
                    ? alpha(theme.palette.common.white, 0.98)
                    : theme.palette.primary.main,
              },
            }}
          >
            <AdminPanelSettingsRounded fontSize="small" />
          </IconButton>
        </Badge>
        {settings.adminMode && (
          <Typography
            variant="caption"
            sx={{
              display: { xs: "none", md: "inline" },
              color: (theme) =>
                theme.palette.mode === "dark"
                  ? alpha(theme.palette.common.white, 0.92)
                  : theme.palette.primary.main,
              fontWeight: 700,
              fontSize: "0.7rem",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
            }}
          >
            {t("Administrador ACTIVO")}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export default Settings;
